import { useStateParams } from 'apps/app/src/hooks/use-state-params';

export const useSelectedInvoiceStateParam = (invoiceId: string | undefined) => {
  return useStateParams<string | undefined>(invoiceId, 'invoiceId', (string) => string, (string) => string);
};